export default {
    optionsMap: {
        "insight": "PrefHinterland",
        "sustainability": "PrefSKIM",
        "public-affairs": "PrefPAList",
        "event": "PrefEvents"
    },
    init() {
        this.form = document.getElementById('gm_form_32');

        if (!this.form)
            return;

        this.initSelectAllButton();
    },
    initSelectAllButton() {
        const button = this.form.querySelector('[data-action=select-all-areas]');

        if (!button)
            return;

        button.addEventListener('click', e => {
            e.preventDefault();

            // Select all checkboxes
            this.form.querySelectorAll('input[type=checkbox]')
                .forEach( el => {
                    el.checked = true;
                });
        });
    }
}
